import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendStaffAppMetaData } from '../../eventTriggers'

export function LivingArrangementHistory() {
  const { living_arrangement_histories } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'living_arrangement_history'))
  const dispatch = useDispatch()

  function handleClick(resource){
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "livingArrangementHistory",
        resource
      }
    })
    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }

  return (
    <div>
      {
        living_arrangement_histories.map(living_arrangement=>(
          <div onClick={()=>handleClick(living_arrangement)} key={living_arrangement.id} className="p-4 border-bottom">
            <b>{living_arrangement.arrangement}</b>
            <div>
              { living_arrangement.started_at } -&nbsp;
              { living_arrangement.ended_at }
            </div>
          </div>
        ))
      }
    </div>
  )
}
